/**
 * Captures the current state of an AG Grid instance
 * @param gridApi - The AG Grid API instance
 * @returns The current grid state or null if gridApi is not available
 */
export function captureGridState(gridApi) {
    if (!gridApi)
        return null;
    const columnState = gridApi.getColumnState();
    const filterModel = gridApi.getFilterModel();
    return {
        columnState,
        rowGroupColumns: [],
        pivotColumns: [],
        filterModel,
        sortModel: []
    };
}
